import { connectGradeOrder } from "@nimble/datamodel/enums/connectGrades";
import { connectSubjectKeys } from "@nimble/datamodel/enums/connectSubjects";
import z from "zod";

import { districtNameSchema } from "@nimble/datamodel/types/district";
import {
  districtNcesIdSchema,
  schoolNcesIdSchema,
} from "@nimble/datamodel/types/ncesId";

export const gradesSchema = z.array(z.enum(connectGradeOrder));

export const subjectsSchema = z.array(z.enum(connectSubjectKeys));

export const getSchoolsByLocationSchema = z.object({
  latitude: z.number().min(-90).max(90),
  longitude: z.number().min(-180).max(180),
  radiusMiles: z.number().min(0).max(100),
});

export type GetSchoolsByLocationParams = z.input<
  typeof getSchoolsByLocationSchema
>;

export const schoolIdAndDistanceSchema = z.object({
  ncesId: schoolNcesIdSchema,
  distanceMiles: z.number().min(0),
});

export type SchoolIdAndDistance = z.infer<typeof schoolIdAndDistanceSchema>;

export const getSchoolsFeaturesParamsSchema = z.object({
  schoolNcesIds: z.array(z.string()),
});

export type GetSchoolsFeaturesParams = z.input<
  typeof getSchoolsFeaturesParamsSchema
>;

export const schoolSoftPreferencesAttributesSchema = z.object({
  ncesId: schoolNcesIdSchema,
  studentTeacherRatio: z.number().nullable(),
  averageSalary: z.number().nullable(),
  noviceTeachersPercentage: z.number().nullable(),
  freeReducedLunchPercentage: z.number().nullable(),
  achievementGrowth: z.number().nullable(),
});

export type SchoolSoftPreferencesAttributes = z.infer<
  typeof schoolSoftPreferencesAttributesSchema
>;

export const schoolFeaturesForRecommendationSchema = z.object({
  nces_id: z.string(),
  distance: z.number(),
  achievement_growth: z.number(),
  novice_teachers_percentage: z.number(),
  free_reduced_lunch_percentage: z.number(),
  student_teacher_ratio: z.number(),
  average_salary: z.number(),
});

export type SchoolFeaturesForRecommendation = z.infer<
  typeof schoolFeaturesForRecommendationSchema
>;

import { AtsTier } from "@nimble/core-client/types";
import { SearchSchoolSummary } from "@nimble/data-service-client/types";

export type Principal = {
  id: number;
  first_name: string;
  last_name: string;
  on_connect: boolean;
};

export type Tag = {
  name: string;
  tooltip_text: string;
  icon: string;
};

export const districtNcesIdAndNameSchema = z.object({
  nces_id: districtNcesIdSchema,
  name: districtNameSchema,
});

export type SchoolSummary = Omit<SearchSchoolSummary, "district"> & {
  district: Omit<SearchSchoolSummary["district"], "nces_id" | "name"> &
    z.infer<typeof districtNcesIdAndNameSchema>;
};

export type SchoolData = SchoolSummary & {
  ats_tier: AtsTier | null;
  principal: Principal | null;
  tags: Tag[];
};
